<template>
  <div class="content-page">
    <div class="breadcrumb">上稿功能 / {{ title }}</div>
    <div class="page-head">
      <div><h1>{{ title }}</h1></div>
    </div>
    <div class="content-card">
      <div class="filters">
        <div class="filter"><span class="filter-label">關鍵字</span>
          <el-input v-model="query.keyword" clearable :placeholder="keywordPlaceholder" @keyup.enter.native="loadList"/>
        </div>
        <div class="filter" v-if="kind==='ad'"><span class="filter-label">廣告位置</span>
          <el-select v-model="query.position" clearable placeholder="請選擇">
            <el-option v-for="item in positions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
          </el-select>
        </div>
        <div class="filter" v-if="kind==='article'"><span class="filter-label">綁定分類</span>
          <el-select v-model="query.categoryId" clearable placeholder="請選擇">
            <el-option v-for="item in flatCategories" :key="item.id" :label="item.optionName || item.name" :value="item.id"/>
          </el-select>
        </div>
        <div class="filter" v-if="kind!=='article'"><span
            class="filter-label">{{ kind === 'category' ? '前台顯示' : '狀態' }}</span>
          <el-select v-model="query.secondary" clearable placeholder="請選擇">
            <el-option v-if="kind==='category'" label="是" value="Y"/>
            <el-option v-if="kind==='category'" label="否" value="N"/>
            <el-option v-if="kind==='ad'" label="有效" value="0"/>
            <el-option v-if="kind==='ad'" label="關閉" value="1"/>
          </el-select>
        </div>
        <div class="filter" v-if="kind==='category'"><span class="filter-label">狀態</span>
          <el-select v-model="query.status" clearable placeholder="請選擇">
            <el-option label="有效" value="0"/>
            <el-option label="關閉" value="1"/>
          </el-select>
        </div>
        <div class="filter" v-if="kind==='article'"><span class="filter-label">發布狀態</span>
          <el-select v-model="query.status" clearable placeholder="請選擇">
            <el-option label="有效" value="0"/>
            <el-option label="關閉" value="1"/>
          </el-select>
        </div>
        <div class="filter ad-date-filter" v-if="kind==='ad'"><span class="filter-label">上架日期</span>
          <div class="ad-date-pair">
            <el-date-picker v-model="adDateStart" class="content-date-range" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="年/月/日"/>
            <span class="ad-date-sep">至</span>
            <el-date-picker v-model="adDateEnd" class="content-date-range" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="年/月/日"/>
          </div>
        </div>
        <div class="filter wide" v-if="kind==='article'"><span class="filter-label">發布日期</span>
          <el-date-picker v-model="dateRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                          range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期"/>
        </div>
        <div class="filter-actions">
          <el-button @click="resetQuery">重設</el-button>
          <el-button class="search-btn" icon="el-icon-search" @click="loadList">查詢</el-button>
          <el-button class="primary-btn" type="primary" icon="el-icon-plus" @click="openForm()">新增{{ entityName }}</el-button>
        </div>
      </div>
      <div class="table-area">
        <el-table :data="displayList" row-key="id" default-expand-all v-loading="loading" empty-text="暫無資料">
          <template v-if="kind==='ad'">
            <el-table-column prop="name" label="廣告名稱" min-width="190"/>
            <el-table-column label="投放位置" min-width="180">
              <template slot-scope="s">{{ positionText(s.row.position) }}</template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" width="80"/>
            <el-table-column label="上架期間" min-width="190">
              <template slot-scope="s">{{ formatDate(s.row.startTime) }}<br>至 {{ formatDate(s.row.endTime) }}
              </template>
            </el-table-column>
          </template>
          <template v-else-if="kind==='category'">
            <el-table-column label="分類名稱" min-width="170">
              <template slot-scope="s"><span class="tree-name">{{ s.row.name }}</span></template>
            </el-table-column>
            <el-table-column prop="introduction" label="介紹" min-width="180" show-overflow-tooltip/>
            <el-table-column prop="customUrl" label="自訂路由" min-width="130"/>
            <el-table-column prop="sort" label="同層排序" width="90"/>
            <el-table-column label="前台顯示" width="100">
              <template slot-scope="s"><span class="status" :class="{off:s.row.showFlag!=='Y'}">{{ s.row.showFlag==='Y' ? '前台顯示' : '否' }}</span></template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column prop="title" label="文章標題" min-width="230"/>
            <el-table-column prop="categoryName" label="綁定分類" min-width="150"/>
            <el-table-column label="作者 / 區域" width="150">
              <template slot-scope="s">{{ s.row.author || '-' }}<br><span class="muted">{{ s.row.region || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="發布日期" width="150">
              <template slot-scope="s">{{ formatDate(s.row.publishTime) }}</template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" width="70"/>
          </template>
          <el-table-column v-if="kind!=='category'" label="狀態" width="90">
            <template slot-scope="s"><span class="status" :class="{off:String(s.row.status)!=='0'}">{{
                statusText(s.row.status)
              }}</span></template>
          </el-table-column>
          <el-table-column v-if="kind==='category'" label="狀態" width="90">
            <template slot-scope="s"><span class="status" :class="{off:String(s.row.status)!=='0'}">{{
                statusText(s.row.status)
              }}</span></template>
          </el-table-column>
          <el-table-column v-if="kind==='ad'||kind==='category'" label="最後更新" width="140"><template slot-scope="s">{{ formatDate(s.row.updateTime) }}</template></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="s"><span class="actions"><button @click="openForm(s.row)">編輯</button><i></i><button class="delete" @click="remove(s.row)">刪除</button></span></template>
          </el-table-column>
        </el-table>
        <div class="pager"><span>{{ countText }}</span>
          <el-pagination background layout="prev, pager, next" :total="total" :current-page="pageNum"
                         :page-size="pageSize" @current-change="changePage"/>
        </div>
      </div>
    </div>
    <aside class="dialog-fixed-right content-drawer" :class="{show:drawer}">
      <div class="dialog-fixed-modal" v-if="drawer" @click="closeDrawer"></div>
      <div class="dialog-fixed-content drawer-content">
        <div class="drawer-head">
          <div><p class="drawer-kicker">上稿功能 / {{ title }}</p>
            <h2>{{ form.id ? '編輯' : '新增' }}{{ entityName }}</h2></div>
          <button @click="closeDrawer"><i class="el-icon-close"/></button>
        </div>
        <div class="drawer-body">
          <ad-form v-if="kind==='ad'" :form="form" :positions="positions" :upload="upload"/>
          <category-form v-else-if="kind==='category'" :form="form" :tree="categoryParentTree" :upload="upload"/>
          <article-form v-else :form="form" :tree="categoryTree" :images="formImages" :upload="upload"
                        :remove-image="removeImage"/>
        </div>
        <div class="drawer-footer">
          <el-button @click="closeDrawer">取消</el-button>
          <el-button class="primary-btn" type="primary" @click="save">儲存資料</el-button>
        </div>
      </div>
    </aside>
  </div>
</template>
<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import './content.scss';
import AdForm from './AdForm.vue';
import CategoryForm from './CategoryForm.vue';
import ArticleForm from './ArticleForm.vue';

export default {
  name: 'ContentPage',
  components: {AdForm, CategoryForm, ArticleForm},
  props: {kind: {type: String, required: true}},
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      drawer: false,
      positions: [],
      categoryTree: [],
      flatCategories: [],
      formImages: [],
      dateRange: [],
      adDateStart: '',
      adDateEnd: '',
      query: {keyword: '', position: '', categoryId: '', secondary: '', status: ''},
      form: {}
    }
  },
  computed: {
    title() {
      return this.kind === 'ad' ? '廣告管理' : this.kind === 'category' ? '分類管理' : '文章管理'
    }, entityName() {
      return this.kind === 'ad' ? '廣告' : this.kind === 'category' ? '分類' : '文章'
    }, description() {
      return this.kind === 'ad' ? '管理網站各個版位的廣告素材與上架期間' : this.kind === 'category' ? '建立文章分類與多層級內容架構' : '綁定分類文章、發布內容與 SEO 資訊'
    }, keywordPlaceholder() {
      return this.kind === 'ad' ? '搜尋廣告名稱、外鏈' : this.kind === 'category' ? '搜尋分類名稱' : '搜尋標題、作者、標籤'
    }, displayList() {
      return this.kind === 'category' ? this.makeTree(this.list) : this.list
    }, categoryParentTree() {
      if (this.kind !== 'category' || !this.form || !this.form.id) return this.categoryTree
      return this.filterCategoryTree(this.categoryTree, this.form.id)
    }, countText() {
      return `共 ${this.total} ${this.kind === 'ad' ? '筆廣告資料' : this.kind === 'category' ? '個分類' : '篇文章'}`
    }
  },
  mounted() {
    this.resetForm();
    if (this.kind === 'ad') this.loadPositions(); else this.loadCategories();
    this.loadList()
  },
  methods: {
    emptyForm() {
      if (this.kind === 'ad') return {
        id: null,
        name: '',
        position: '',
        positionList: [],
        pcImage: '',
        wapImage: '',
        externalUrl: '',
        sort: 0,
        introduction: '',
        startTime: '',
        endTime: '',
        status: '0'
      };
      if (this.kind === 'category') return {
        id: null,
        parentId: 0,
        parentPath: [],
        name: '',
        image: '',
        externalUrl: '',
        customUrl: '',
        introduction: '',
        sort: 0,
        showFlag: 'Y',
        status: '0'
      };
      return {
        id: null,
        categoryId: null,
        categoryPath: [],
        title: '',
        author: '',
        region: '',
        summary: '',
        tags: '',
        coverImage: '',
        images: '',
        externalUrl: '',
        customUrl: '',
        publishTime: '',
        sort: 0,
        content: '',
        remark1: '',
        remark2: '',
        seoTitle: '',
        seoKeywords: '',
        seoDescription: '',
        status: '0'
      }
    }, resetForm() {
      this.form = this.emptyForm()
    }, loadPositions() {
      this.$axios.post('rest-api/system/app/common/dict-data/list', {dictType: 'content_ad_position'}).then(r => {
        this.positions = r.data || []
      }).catch(() => {
        this.positions = []
      })
    }, contentBase() {
      // Keep the public address used by the original content integration.
      return 'rest-api/content'
    }, contentResource() {
      return this.kind === 'ad' ? 'ad' : this.kind === 'category' ? 'article-category' : 'article'
    }, loadCategories() {
      this.$axios.post('rest-api/content/article-category/tree', {}).then(r => {
        this.categoryTree = this.normalizeCategoryTree(r.data || []);
        this.flatCategories = this.flatten(this.categoryTree)
      }).catch(() => {
        this.categoryTree = [];
        this.flatCategories = []
      })
    }, normalizeCategoryTree(list) {
      return (list || []).map(node => {
        const id = node.id != null ? String(node.id) : '';
        const parentId = node.parentId != null ? String(node.parentId) : '';
        const name = node.name || node.label || node.title || '';
        const item = Object.assign({}, node, {
          id,
          parentId,
          name,
          label: name,
          value: id
        });
        delete item.disabled;
        const children = this.normalizeCategoryTree(node.children || []);
        if (children.length) item.children = children; else delete item.children;
        return item
      })
    }, filterCategoryTree(list, excludeId) {
      const targetId = excludeId != null ? String(excludeId) : '';
      return (list || []).filter(node => String(node.id) !== targetId).map(node => {
        const item = Object.assign({}, node);
        const children = this.filterCategoryTree(node.children || [], targetId);
        if (children.length) item.children = children; else delete item.children;
        return item
      })
    }, toNumber(v) {
      if (v === '' || v === null || v === undefined) return 0;
      const n = Number(v);
      return Number.isNaN(n) ? v : n
    }, flatten(a, out = [], level = 0) {
      (a || []).forEach(n => {
        const item = Object.assign({}, n, {
          optionName: `${level ? '　'.repeat(level) + '└ ' : ''}${n.name}`
        });
        out.push(item);
        this.flatten(n.children, out, level + 1)
      });
      return out
    }, makeTree(a) {
      const map = {}, roots = [];
      (a || []).forEach(n => {
        map[n.id] = Object.assign({children: []}, n)
      });
      Object.values(map).forEach(n => {
        if (n.parentId && map[n.parentId]) map[n.parentId].children.push(n); else roots.push(n)
      });
      return roots
    }, loadList() {
      this.loading = true;
      const b = {};
      if (this.kind === 'ad') {
        b.name = this.query.keyword;
        b.position = this.query.position;
        b.status = this.query.secondary
      } else if (this.kind === 'category') {
        b.name = this.query.keyword;
        b.showFlag = this.query.secondary;
        b.status = this.query.status
      } else {
        b.title = this.query.keyword;
        b.categoryId = this.query.categoryId;
        b.status = this.query.status
      }
      if (this.dateRange && this.dateRange.length === 2) {
        if (this.kind === 'article') {
          b.publishTimeBegin = this.dateRange[0];
          b.publishTimeEnd = this.dateRange[1]
        }
      }
      if (this.kind === 'ad') {
        b.startTimeBegin = this.adDateStart;
        b.endTimeEnd = this.adDateEnd
      }
      b.pageNum = this.pageNum;
      b.pageSize = this.pageSize;
      const endpoint = this.kind === 'category' ? 'list' : 'page';
      this.$axios.post(`${this.contentBase()}/${this.contentResource()}/${endpoint}`, b).then(r => {
        if (this.kind === 'category') {
          this.list = r.data || [];
          this.total = this.list.length;
          return;
        }
        const page = r.data || {};
        this.list = page.list || [];
        this.total = page.total == null ? this.list.length : page.total
      }).catch(() => {
        this.list = [];
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    }, resetQuery() {
      this.query = {keyword: '', position: '', categoryId: '', secondary: '', status: ''};
      this.dateRange = [];
      this.adDateStart = '';
      this.adDateEnd = '';
      this.pageNum = 1;
      this.loadList()
    }, changePage(p) {
      this.pageNum = p;
      this.loadList()
    }, openForm(row) {
      this.form = row ? Object.assign(this.emptyForm(), row) : this.emptyForm();
      if (this.kind === 'ad') this.form.positionList = this.imageList(this.form.position);
      if (this.kind === 'category') this.form.parentPath = this.path(row && row.parentId);
      if (this.kind === 'article') {
        this.form.categoryPath = this.path(row && row.categoryId);
        this.formImages = this.imageList(this.form.images)
      }
      this.drawer = true
    }, openChild(row) {
      this.resetForm();
      this.form.parentId = row.id;
      this.form.parentPath = this.path(row.id);
      this.drawer = true
    }, path(id) {
      const r = [];
      let n = this.flatCategories.find(x => String(x.id) === String(id));
      while (n) {
        r.unshift(n.id);
        n = this.flatCategories.find(x => String(x.id) === String(n.parentId))
      }
      return r
    }, closeDrawer() {
      this.drawer = false
    }, upload(file, field) {
      const fd = new FormData();
      fd.append('file', file);
      this.$axios.post('rest-api/resource/oss/upload', fd).then(r => {
        if (field === 'images') this.formImages.push(r.data.url); else this.form[field] = r.data.url
      }).catch(() => {
      })
    }, imageList(v) {
      return v ? String(v).split(',').filter(Boolean) : []
    }, positionLabel(v) {
      const p = this.positions.find(x => x.dictValue === v);
      return p ? p.dictLabel : v
    }, positionText(v) {
      return this.imageList(v).map(item => this.positionLabel(item)).join('、') || '-'
    }, formatDate(v) {
      return v ? String(v).replace('T', ' ').slice(0, 16) : '-'
    }, statusText(v) {
      return String(v) === '0' ? '有效' : '關閉'
    }, showText(v) {
      return v === 'Y' ? '是' : '否'
    }, save() {
      if (this.kind === 'ad') {
        if (this.form.id) {
          if (!this.form.position) return this.$message.warning('請選擇一個投放位置');
        } else {
          if (!this.form.positionList.length) return this.$message.warning('請至少選擇一個投放位置');
          this.form.position = this.form.positionList.join(',');
        }
      }
      const parentPath = Array.isArray(this.form.parentPath) ? this.form.parentPath : [];
      const categoryPath = Array.isArray(this.form.categoryPath) ? this.form.categoryPath : [];
      if (this.kind === 'category') this.form.parentId = parentPath.length ? parentPath[parentPath.length - 1] : 0;
      if (this.kind === 'article') {
        if (!categoryPath.length || !this.form.title) return this.$message.warning('請填寫文章標題並選擇分類');
        this.form.categoryId = categoryPath[categoryPath.length - 1];
        this.form.images = this.formImages.join(',')
      }
      const u = `${this.contentBase()}/${this.contentResource()}/${this.form.id ? 'edit' : 'add'}`;
      this.$axios.post(u, this.form).then(() => {
        this.$message.success('儲存成功');
        this.closeDrawer();
        this.loadList();
        if (this.kind !== 'ad') this.loadCategories()
      }).catch(() => {
      })
    }, remove(row) {
      this.$confirm('確定要刪除此筆資料嗎？', '提示', {type: 'warning'}).then(() => this.$axios.post(`${this.contentBase()}/${this.contentResource()}/delete`, {id: row.id})).then(() => {
        this.$message.success('刪除成功');
        this.loadList()
      }).catch(() => {
      })
    }, removeImage(i) {
      this.formImages.splice(i, 1)
    }
  }
};
</script>
